/**
 * Grid of every extracted frame. Clicking a frame opens FrameModal with the
 * full Claude analysis for that frame.
 */
import React from 'react';
import { frameImageUrl } from '../api/api';

export default function FrameGallery({ jobId, frames = [], onSelectFrame }) {
  if (!frames.length) {
    return <p className="text-gray-400 text-sm">No frames available.</p>;
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
      {frames.map((frame) => (
        <button
          key={frame.frameNumber}
          type="button"
          onClick={() => onSelectFrame(frame)}
          className="group relative rounded-lg overflow-hidden border border-gray-200 bg-gray-100 aspect-video"
        >
          <img
            src={frameImageUrl(jobId, frame.fileName)}
            alt={`Frame at ${frame.timestamp}`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform"
            loading="lazy"
          />
          <span className="absolute bottom-1 right-1 bg-black/70 text-white text-[10px] font-mono px-1.5 py-0.5 rounded">
            {frame.timestamp}
          </span>
        </button>
      ))}
    </div>
  );
}
